import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function ValueStack() {
  return <section className="py-24 px-4 bg-gradient-to-b from-background to-zinc-900/50" data-id="element-71" data-mp="2495l55lzlu9s">
      <div className="max-w-4xl mx-auto" data-id="element-72" data-mp="1q94oy3go3b0n">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-73" data-mp="1qa62cel5o9lj">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-74" data-mp="2my3z5o0tamvh">
            The Mid-Year Domination Bundle
          </h2>
        </motion.div>

        <div className="bg-zinc-900 border border-green-500/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(34,197,94,0.1)] relative overflow-hidden" data-id="element-75" data-mp="2d8snbtmjj43w">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-76" data-mp="30wtv30bwagi9" />

          <div className="space-y-6 relative z-10" data-id="element-77" data-mp="35r7q31mnalme">
            <div className="flex items-start gap-4 p-5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-78" data-mp="1tgel44e6vwvu">
              <div className="bg-green-500/20 p-3 rounded-lg shrink-0" data-id="element-79" data-mp="1oe73ay6ohmll">
                <Gift className="w-6 h-6 text-green-400" data-id="element-80" data-mp="235y3za1wjqqp" />
              </div>
              <div data-id="element-81" data-mp="1ye694nbpqyur">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-82" data-mp="1ydo9dgpue2i3">
                  <h3 className="text-lg font-bold text-white" data-id="element-83" data-mp="2c533ailafo3x">
                    Bonus 1: THE BRAIN KILLER
                  </h3>
                  <span className="text-xs font-bold px-2 py-1 bg-green-500/20 text-green-400 rounded-full" data-id="element-84" data-mp="283pt5wb5wyr7">
                    FREE ($47 Value)
                  </span>
                </div>
                <p className="text-gray-400" data-id="element-85" data-mp="2h5gzn3dj19m4">
                  Identify the hidden toxins in your home triggering your
                  fatigue.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-86" data-mp="mshfqy245t91">
              <div className="bg-green-500/20 p-3 rounded-lg shrink-0" data-id="element-87" data-mp="2rs91ejugap3o">
                <Gift className="w-6 h-6 text-green-400" data-id="element-88" data-mp="2rsip20s0wk67" />
              </div>
              <div data-id="element-89" data-mp="2vt2l110v1hqr">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-90" data-mp="2vvymgzbx2ojy">
                  <h3 className="text-lg font-bold text-white" data-id="element-91" data-mp="30tqc1mp39ykz">
                    Bonus 2: THE 7-DAY BIOLOGIC RESET
                  </h3>
                  <span className="text-xs font-bold px-2 py-1 bg-green-500/20 text-green-400 rounded-full" data-id="element-92" data-mp="35q7ab9q05tbs">
                    FREE ($37 Value)
                  </span>
                </div>
                <p className="text-gray-400" data-id="element-93" data-mp="3fk7dh61q4ohv">
                  The emergency protocol to transition from "Sluggish" to
                  "Sharp" in one week.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center relative z-10" data-id="element-94" data-mp="3th2zs06zkcfv">
            <div className="flex flex-col items-center justify-center" data-id="element-95" data-mp="7fvo82pdl3l0">
              <span className="text-gray-500 line-through text-xl mb-2 font-medium" data-id="element-96" data-mp="7e2h6mauohch">
                Total Value: $131
              </span>
              <div className="flex items-baseline gap-3" data-id="element-97" data-mp="3tmty51wheb3y">
                <span className="text-2xl text-gray-300 font-medium" data-id="element-98" data-mp="3tpg4wzbjsml4">
                  Your Price Today:
                </span>
                <span className="text-6xl font-extrabold text-green-400 tracking-tight" data-id="element-99" data-mp="q6d9xnbsiywv">
                  $27
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}